import FormControls from 'component/FormControls';
import Page from 'component/Page';
import { useState } from 'react';
import { Button, Form, Row } from 'react-bootstrap';
import { sendPut } from 'util/request';
import string from 'util/string';
import Urls from 'util/urls';
import {
  focusElement,
  getFormData,
  showConfirm,
  emailValidate,
  showToast,
} from 'util/utils';
import { RiEyeCloseLine } from 'react-icons/ri';
import { ImEye } from 'react-icons/im';

const UserIdUpdate = ({ data = { id: null, valid: true }, onUpdated }) => {
  //-------------------------------HOOKS-------------------------------------------------------------
  const [showPassword, setShowPassword] = useState(false);

  //------------------------FUNCTIONS----------------------------------------------------------
  const onSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    let formData = getFormData(e.target, {
      rawCol: {
				customerId: true,
      },
    });

    if (!formData.customerId) {
      showToast(string.ACCOUNT_CUSTOMER_ID_EMPTY_ERROR);
      focusElement('#customerId');
      return;
    }
    showConfirm({
      body: string.ACCOUNT_CUSTOMER_ID_UPDATE_CONFIRM,
      defaultAction: () => {
        sendPut({
          url: Urls.admin.customerid,
          body: {
            id: data?.id,
            ...formData,
            accountRole: 1,
          },
        })
          .then((res) => {
            showToast(string.ACCOUNT_CUSTOMER_ID_UPDATE_SUCCESS, 'success');
            onUpdated(res);
          })
          .catch((e) => {});
      },
    });
  };

  //------------------------------------RETURN---------------------------------------------------------
  return (
    <>
      <Page
        title={string.ACCOUNT_CUSTOMER_ID_UPDATE_TITLE}
        body={
          <>
						<FormControls
							data={data}
							controls={[
								{
									id: 'email',
									title: string.SIGNUP_MAIL_TITLE,
									readOnly: true,
								},
								{
									id: 'usernameKanji',
									title: string.SIGNUP_NAME_TITLE,
									readOnly: true,
								},
								{
									id: 'usernameHira',
									title: string.SIGNUP_FURIGANA_TITLE,
									readOnly: true,
								},
								{
									id: 'phoneNumber',
									title: string.SIGNUP_PHONE_TITLE,
									readOnly: true,
								},
							]}
							footer={<></>}
						/>
						<Form onSubmit={onSubmit}>
              <FormControls
                data={data}
                controls={[
                  {
                    id: 'customerId',
                    title: string.ACCOUNT_CUSTOMER_ID,
                  },
                ]}
                footer={<></>}
              />
              <Row className="form-button-row">
                <Button type="submit">{string.ACCOUNT_CUSTOMER_ID_UPDATE}</Button>
              </Row>
            </Form>
          </>
        }
      />
    </>
  );
};

export default UserIdUpdate;
